import {getGlossary} from "./utils/languages";

export default {
    API_URL : 'https://apiportal.kian-ph.com',//'http://192.168.123.50:8024',//'https://wallbillapi.kian-ph.com',
    glossary: getGlossary("fa")
}
export const MOBILE_FORMAT_REGEX = new RegExp('^(0)9?\\d{10}$');
export const EMAIL_REGEX=new RegExp('^[a-zA-Z0-9._:$!%-]+@[a-zA-Z0-9.-]+.[a-zA-Z]$');
export const colors = [
    "green",
    "purple",
    "yellow",
    "blue",
    "pink",
    "red",
];
export const local_icon_dir = `${process.env.PUBLIC_URL}/assets/icon/{{ICON}}.svg`;
export const local_image_dir = `${process.env.PUBLIC_URL}/assets/images/{{IMAGE}}`;
export const COUNT_DOWN_INIT = 160;
export const walltax = "20ffc344-e27b-ee11-a5ae-005056b82b8f"
export const testToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6Iis5ODkxMjMwMTk0MjMiLCJzdWIiOiIrOTg5MTIzMDE5NDIzIiwiZW1haWwiOiJtQG0uY29tIiwiQ3JlYXRlZE9uIjoiMjAyMy0wNi0wMyIsImp0aSI6IjJkNDVhNmM2LTc4NzMtNDljMC05M2VhLTVkZDk4MjQ5ODI4ZiIsImV4cCI6MTcyOTk0NjQyNiwiaXNzIjoia2lhbi1waC5jb20iLCJhdWQiOiJraWFuLXBoLmNvbSJ9.yVknPKLf_AravNixo6QrgvR7zVo2Z8dlM3_Epigzmjs"
export const animationDelays = [100,200,300]
